import React from "react";

// React 17 unmounts the whole dashboard when a page throws while rendering,
// which leaves a blank screen. This keeps the failure to the page and offers
// a way out. Navigating elsewhere (a new resetKey) tries again.
class ErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidUpdate(previous) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="hx-crash" role="alert">
        <h1>This page couldn't be shown</h1>
        <p>Something went wrong while loading it. Go back and try again, or reload the dashboard.</p>
        <div className="hx-crash-actions">
          <button type="button" className="hx-btn is-ghost" onClick={() => window.history.back()}>
            Go back
          </button>
          <button type="button" className="hx-btn" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
